// 20.02.26 - More page for mobile bottom nav - links to all other sections
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './MorePage.css';

const menuItems = [
  { icon: '✉️', label: 'Emails',      path: '/emails' },
  { icon: '🔔', label: 'Reminders',   path: '/reminders' },
  { icon: '🎯', label: 'Goals',       path: '/goals' },
  { icon: '📋', label: 'Noticeboard', path: '/noticeboard' },
  { icon: '👤', label: 'Account',     path: '/account' },
  { icon: '⚙️', label: 'Settings',   path: '/settings' },
];

const MorePage = () => {
  const navigate = useNavigate();

  return (
    <div className="more-page">
      <h1 className="more-title">More</h1>
      <div className="more-list">
        {menuItems.map((item) => (
          <button
            key={item.path}
            className="more-item"
            onClick={() => navigate(item.path)}
          >
            <span className="more-icon">{item.icon}</span>
            <span className="more-label">{item.label}</span>
            <span className="more-arrow">›</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default MorePage;